import React, { useEffect, useState } from "react";
import { Alert } from "shards-react";

/**
 * Displays an alert for a period of time
 */
const DismissAlert = ({ message, type, toggle, timeoutMs = 1000 }) => {
  const [visible, setVisible] = useState(true);

  // When 'active' toggles, the alert is shown
  useEffect(() => {
    console.log("activar");
    setVisible(true);
    const timeId = setTimeout(() => {
      setVisible(false);
    }, timeoutMs);
    return () => clearTimeout(timeId);
  }, [toggle]);

  return (
    visible && (
      <div>
        <Alert className="mt-2" open={visible} theme={type}>
          {message}
        </Alert>
      </div>
    )
  );
};

export default DismissAlert;
